import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "-mx-6 w-[calc(100%+48px)] pb-6" }
const _hoisted_2 = { class: "grid grid-cols-12 gap-6 py-6 mx-6" }
const _hoisted_3 = { class: "col-span-4" }
const _hoisted_4 = { class: "col-span-4" }
const _hoisted_5 = { class: "col-span-4" }
const _hoisted_6 = { class: "p-6 mx-6 border rounded-lg border-neutral-100" }
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "grid items-start grid-cols-6 gap-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "col-span-6 text-sm font-medium text-neutral-600" }, " Personal Information ", -1)
const _hoisted_11 = { class: "grid grid-cols-3 col-span-3 gap-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Full Name:")
], -1)
const _hoisted_13 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Sex:")
], -1)
const _hoisted_15 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Gender:")
], -1)
const _hoisted_17 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Birthdate:")
], -1)
const _hoisted_19 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Age: ")
], -1)
const _hoisted_21 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Civil Status:")
], -1)
const _hoisted_23 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Contact Number:")
], -1)
const _hoisted_25 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Lives w/ Child:")
], -1)
const _hoisted_27 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Case Number:")
], -1)
const _hoisted_29 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Primary Diagnosis:")
], -1)
const _hoisted_31 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Informant relation to child:")
], -1)
const _hoisted_33 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Other Relationship:")
], -1)
const _hoisted_35 = { class: "col-span-2" }
const _hoisted_36 = { class: "grid grid-cols-3 col-span-3 gap-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Services sought:")
], -1)
const _hoisted_38 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Social worker:")
], -1)
const _hoisted_40 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "External referral from:")
], -1)
const _hoisted_42 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Intra-PGH referral from:")
], -1)
const _hoisted_44 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "If inpatient, which ward referred:")
], -1)
const _hoisted_46 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Legal Status:")
], -1)
const _hoisted_48 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Housing Classification:")
], -1)
const _hoisted_50 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Socio Eco Status:")
], -1)
const _hoisted_52 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "No. of Children in Family:")
], -1)
const _hoisted_54 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 pb-2 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "No. of Household Members:")
], -1)
const _hoisted_56 = { class: "col-span-2 pb-2 pl-3 border-b border-gray-100" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "No. of Families in Household:")
], -1)
const _hoisted_58 = { class: "col-span-2" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "mt-12 border-t border-gray-200" }, null, -1)
const _hoisted_60 = { class: "grid items-start grid-cols-6 gap-6" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", { class: "col-span-6 text-sm font-medium text-neutral-600" }, " Address and Present Location ", -1)
const _hoisted_63 = { class: "relative w-full col-span-3 p-4 pr-8 border border-gray-200 rounded" }
const _hoisted_64 = { class: "w-full" }
const _hoisted_65 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Address Type:")
], -1)
const _hoisted_67 = { class: "py-2" }
const _hoisted_68 = { class: "font-normal" }
const _hoisted_69 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Address:")
], -1)
const _hoisted_71 = { class: "py-2" }
const _hoisted_72 = { class: "font-normal" }
const _hoisted_73 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Barangay:")
], -1)
const _hoisted_75 = { class: "py-2" }
const _hoisted_76 = { class: "font-normal" }
const _hoisted_77 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "City/Municipality/District:")
], -1)
const _hoisted_79 = { class: "py-2" }
const _hoisted_80 = { class: "font-normal" }
const _hoisted_81 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Province:")
], -1)
const _hoisted_83 = { class: "py-2" }
const _hoisted_84 = { class: "font-normal" }
const _hoisted_85 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Region:")
], -1)
const _hoisted_87 = { class: "py-2" }
const _hoisted_88 = { class: "font-normal" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Direction:")
], -1)
const _hoisted_90 = { class: "py-2" }
const _hoisted_91 = { class: "font-normal" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "mt-12 border-t border-gray-200" }, null, -1)
const _hoisted_93 = { class: "grid items-start grid-cols-6 gap-6" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, null, -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("p", { class: "col-span-6 text-sm font-medium text-neutral-600" }, " Persons Related to Case ", -1)
const _hoisted_96 = { class: "relative w-full col-span-3 p-4 pr-8 border border-gray-200 rounded" }
const _hoisted_97 = { class: "w-full" }
const _hoisted_98 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Full Name:")
], -1)
const _hoisted_100 = { class: "py-2" }
const _hoisted_101 = { class: "font-normal" }
const _hoisted_102 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Gender:")
], -1)
const _hoisted_104 = { class: "py-2" }
const _hoisted_105 = { class: "font-normal" }
const _hoisted_106 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Relationship:")
], -1)
const _hoisted_108 = { class: "py-2" }
const _hoisted_109 = { class: "font-normal" }
const _hoisted_110 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Birthdate:")
], -1)
const _hoisted_112 = { class: "py-2" }
const _hoisted_113 = { class: "font-normal" }
const _hoisted_114 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Age:")
], -1)
const _hoisted_116 = { class: "py-2" }
const _hoisted_117 = { class: "font-normal" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Contact Number:")
], -1)
const _hoisted_119 = { class: "py-2" }
const _hoisted_120 = { class: "font-normal" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("div", { class: "mt-12 border-t border-gray-200" }, null, -1)
const _hoisted_122 = { class: "grid items-start grid-cols-6 gap-6" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, null, -1)
const _hoisted_124 = /*#__PURE__*/_createElementVNode("p", { class: "col-span-6 text-sm font-medium text-neutral-600" }, " Contact Numbers ", -1)
const _hoisted_125 = { class: "relative w-full col-span-3 p-4 pr-8 border border-gray-200 rounded" }
const _hoisted_126 = { class: "w-full" }
const _hoisted_127 = { key: 0 }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("tbody", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-b border-gray-100 border-solid" }, [
    /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Label:")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, " Contact Numbers:")
    ])
  ])
], -1)
const _hoisted_129 = [
  _hoisted_128
]
const _hoisted_130 = { key: 1 }
const _hoisted_131 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Label:")
], -1)
const _hoisted_133 = { class: "py-2" }
const _hoisted_134 = { class: "font-normal" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, " Contact Numbers:")
], -1)
const _hoisted_136 = { class: "py-2" }
const _hoisted_137 = { class: "font-normal" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("div", { class: "mt-12 border-t border-gray-200" }, null, -1)
const _hoisted_139 = { class: "grid items-start grid-cols-6 gap-6" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, null, -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("p", { class: "col-span-6 text-sm font-medium text-neutral-600" }, " Email Addresses ", -1)
const _hoisted_142 = { class: "relative w-full col-span-3 p-4 pr-8 border border-gray-200 rounded" }
const _hoisted_143 = { class: "w-full" }
const _hoisted_144 = { key: 0 }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("tbody", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-b border-gray-100 border-solid" }, [
    /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Label:")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, " Email Address:")
    ])
  ])
], -1)
const _hoisted_146 = [
  _hoisted_145
]
const _hoisted_147 = { key: 1 }
const _hoisted_148 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Label:")
], -1)
const _hoisted_150 = { class: "py-2" }
const _hoisted_151 = { class: "font-normal" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, " Email Address:")
], -1)
const _hoisted_153 = { class: "py-2" }
const _hoisted_154 = { class: "font-normal" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", { class: "mt-12 border-t border-gray-200" }, null, -1)
const _hoisted_156 = { class: "grid items-start grid-cols-6 gap-6" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, null, -1)
const _hoisted_158 = /*#__PURE__*/_createElementVNode("p", { class: "col-span-6 text-sm font-medium text-neutral-600" }, " Incest Cases ", -1)
const _hoisted_159 = { class: "col-span-6" }
const _hoisted_160 = { class: "w-full" }
const _hoisted_161 = { class: "border-b border-gray-100 border-solid" }
const _hoisted_162 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Regular sleeping arrangement:")
], -1)
const _hoisted_163 = { class: "py-2" }
const _hoisted_164 = { class: "font-normal" }
const _hoisted_165 = { class: "align-top border-b border-gray-100 border-solid" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Specify:")
], -1)
const _hoisted_167 = { class: "py-2" }
const _hoisted_168 = { class: "font-normal" }
const _hoisted_169 = { class: "align-top border-b border-gray-100 border-solid" }
const _hoisted_170 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, " Same bed / mat with:")
], -1)
const _hoisted_171 = { class: "py-2 frm-description" }
const _hoisted_172 = { class: "font-normal" }
const _hoisted_173 = { class: "align-top border-b border-gray-100 border-solid" }
const _hoisted_174 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, " Same room with:")
], -1)
const _hoisted_175 = { class: "py-2 frm-description" }
const _hoisted_176 = { class: "font-normal" }
const _hoisted_177 = { class: "align-top border-b border-gray-100 border-solid" }
const _hoisted_178 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, " Living arrangement at time of abuse:")
], -1)
const _hoisted_179 = { class: "py-2 frm-description" }
const _hoisted_180 = { class: "font-normal" }
const _hoisted_181 = { class: "align-top" }
const _hoisted_182 = /*#__PURE__*/_createElementVNode("td", { class: "w-[200px] py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, " Living arrangement at present:")
], -1)
const _hoisted_183 = { class: "py-2 frm-description" }
const _hoisted_184 = { class: "font-normal" }

import { onMounted, ref, computed, watch } from 'vue';
import UserLayout from "@/layouts/UserLayout.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import ExportButton from '@/components/buttons/ExportButton.vue';
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import LoadingModal from '@/components/modals/LoadingModal.vue';
import { useNetworkStore } from "@/store/network";
import ReportService from "@/classes/Reports/ReportService";
import IntakeFormService from "@/classes/Cases/IntakeForms/IntakeFormService";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportIntake',
  setup(__props) {

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
const cases = ref<any>([]);
const item = ref();
const showSync = ref<boolean>(false);


const filters = ref({
    case_id: null,
})

const first_name = computed(() => item?.value?.first_name ?? '')
const last_name = computed(() => item?.value?.last_name ?? '')

const fetch = () => {
    showSync.value = true

    ReportService.index('intake-form', filters.value)
        .then(({ data }) => {
            console.log(data)
            cases.value = data?.cases
            item.value = data?.item;

            showSync.value = false
        })
        .catch(errors => {
            showSync.value = false
            console.log(errors)
        });
}

const generatePDFAccess = ():void => {
	IntakeFormService
		.generatePDFAccess(
			item.value.patient_id,
			item.value.case_id,
            isNetworkAvailable.value
		)
		.then(({data}) => {
			if(data.token){
				downloadPDF(data.token)
			}
		}).catch((errors) => {
			console.log(errors);
		})

}
const downloadPDF = (token:string):void => {
	IntakeFormService
		.downloadPDF(
			item.value.patient_id,
			item.value.case_id,
			token,
			isNetworkAvailable.value
		)
		.then(({data}) => {
			console.log(data);
		}).catch((errors) => {
			console.log(errors);
		})

}

watch(
() => filters.value.case_id,
	() => {
		fetch();
	}
);

onMounted(() => {
    fetch()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backTitle: "Intake Report",
    backLink: "/reports"
  }, {
    lowerRight: _withCtx(() => [
      (item.value)
        ? (_openBlock(), _createBlock(ExportButton, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (generatePDFAccess()))
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(MultiSelect, {
              options: cases.value,
              id: "case_id",
              name: "case_id",
              label: "Case Number",
              placeholder: "Select..",
              searchable: "",
              modelValue: filters.value.case_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.case_id) = $event))
            }, null, 8, ["options", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TextInput, {
              placeholder: "Patient last name",
              id: "patient_last_name",
              name: "patient_last_name",
              label: "Patient Last Name",
              disabled: "",
              modelValue: last_name.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((last_name).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(TextInput, {
              placeholder: "Patient first name",
              id: "patient_first_name",
              name: "patient_first_name",
              label: "Patient First Name",
              disabled: "",
              modelValue: first_name.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((first_name).value = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(SectionTitle, { title: "Intake" })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("p", null, _toDisplayString(item.value?.name), 1)
              ]),
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", null, _toDisplayString(item.value?.sex_form), 1)
              ]),
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", null, _toDisplayString(item.value?.gender), 1)
              ]),
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("p", null, _toDisplayString(item.value?.birthdate || "Unknown"), 1)
              ]),
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("p", null, _toDisplayString(item.value?.age) + "  ", 1)
              ]),
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("p", null, _toDisplayString(item.value?.civil_status), 1)
              ]),
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("p", null, _toDisplayString(item.value?.contacts), 1)
              ]),
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("p", null, _toDisplayString(item.value?.lives_w_child), 1)
              ]),
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("p", null, _toDisplayString(item.value?.case_number), 1)
              ]),
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("p", null, _toDisplayString(item.value?.primary_diagnosis), 1)
              ]),
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("p", null, _toDisplayString(item.value?.informant_relation_child), 1)
              ]),
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("p", null, _toDisplayString(item.value?.other_relationship), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("p", null, _toDisplayString(item.value?.services_sought), 1)
              ]),
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("p", null, _toDisplayString(item.value?.social_worker), 1)
              ]),
              _hoisted_41,
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("p", null, _toDisplayString(item.value?.external_referral), 1)
              ]),
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("p", null, _toDisplayString(item.value?.intra_referral), 1)
              ]),
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("p", null, _toDisplayString(item.value?.inpatient_referred), 1)
              ]),
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("p", null, _toDisplayString(item.value?.legal_status), 1)
              ]),
              _hoisted_49,
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("p", null, _toDisplayString(item.value?.housing_classification), 1)
              ]),
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("p", null, _toDisplayString(item.value?.socio_economic_status), 1)
              ]),
              _hoisted_53,
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("p", null, _toDisplayString(item.value?.no_children_in_family), 1)
              ]),
              _hoisted_55,
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("p", null, _toDisplayString(item.value?.no_household_members), 1)
              ]),
              _hoisted_57,
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("p", null, _toDisplayString(item.value?.no_family_in_household), 1)
              ])
            ])
          ]),
          _hoisted_59,
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            _hoisted_62,
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("table", _hoisted_64, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_65, [
                    _hoisted_66,
                    _createElementVNode("td", _hoisted_67, [
                      _createElementVNode("p", _hoisted_68, _toDisplayString(item.value?.address?.address_type), 1)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_69, [
                    _hoisted_70,
                    _createElementVNode("td", _hoisted_71, [
                      _createElementVNode("p", _hoisted_72, _toDisplayString(item.value?.address?.current), 1)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_73, [
                    _hoisted_74,
                    _createElementVNode("td", _hoisted_75, [
                      _createElementVNode("p", _hoisted_76, _toDisplayString(item.value?.address?.cur_barangay), 1)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_77, [
                    _hoisted_78,
                    _createElementVNode("td", _hoisted_79, [
                      _createElementVNode("p", _hoisted_80, _toDisplayString(item.value?.address?.cur_city), 1)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_81, [
                    _hoisted_82,
                    _createElementVNode("td", _hoisted_83, [
                      _createElementVNode("p", _hoisted_84, _toDisplayString(item.value?.address?.cur_province), 1)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_85, [
                    _hoisted_86,
                    _createElementVNode("td", _hoisted_87, [
                      _createElementVNode("p", _hoisted_88, _toDisplayString(item.value?.address?.cur_region), 1)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_89,
                    _createElementVNode("td", _hoisted_90, [
                      _createElementVNode("p", _hoisted_91, _toDisplayString(item.value?.address?.current_directions), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_92,
          _createElementVNode("div", _hoisted_93, [
            _hoisted_94,
            _hoisted_95,
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("table", _hoisted_97, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value?.familyComposition, (li) => {
                  return (_openBlock(), _createElementBlock("tbody", {
                    key: li.name
                  }, [
                    _createElementVNode("tr", _hoisted_98, [
                      _hoisted_99,
                      _createElementVNode("td", _hoisted_100, [
                        _createElementVNode("p", _hoisted_101, _toDisplayString(li?.name), 1)
                      ])
                    ]),
                    _createElementVNode("tr", _hoisted_102, [
                      _hoisted_103,
                      _createElementVNode("td", _hoisted_104, [
                        _createElementVNode("p", _hoisted_105, _toDisplayString(li?.gender), 1)
                      ])
                    ]),
                    _createElementVNode("tr", _hoisted_106, [
                      _hoisted_107,
                      _createElementVNode("td", _hoisted_108, [
                        _createElementVNode("p", _hoisted_109, _toDisplayString(li?.relationship), 1)
                      ])
                    ]),
                    _createElementVNode("tr", _hoisted_110, [
                      _hoisted_111,
                      _createElementVNode("td", _hoisted_112, [
                        _createElementVNode("p", _hoisted_113, _toDisplayString(li.birthdate), 1)
                      ])
                    ]),
                    _createElementVNode("tr", _hoisted_114, [
                      _hoisted_115,
                      _createElementVNode("td", _hoisted_116, [
                        _createElementVNode("p", _hoisted_117, _toDisplayString(li?.age), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_118,
                      _createElementVNode("td", _hoisted_119, [
                        _createElementVNode("p", _hoisted_120, _toDisplayString(li.contact), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _hoisted_121,
          _createElementVNode("div", _hoisted_122, [
            _hoisted_123,
            _hoisted_124,
            _createElementVNode("div", _hoisted_125, [
              _createElementVNode("table", _hoisted_126, [
                (!item.value?.contactNumbers)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_127, _hoisted_129))
                  : (_openBlock(), _createElementBlock("div", _hoisted_130, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value?.contactNumbers, (li) => {
                        return (_openBlock(), _createElementBlock("tbody", {
                          key: li.label
                        }, [
                          _createElementVNode("tr", _hoisted_131, [
                            _hoisted_132,
                            _createElementVNode("td", _hoisted_133, [
                              _createElementVNode("p", _hoisted_134, _toDisplayString(li?.label), 1)
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_135,
                            _createElementVNode("td", _hoisted_136, [
                              _createElementVNode("p", _hoisted_137, _toDisplayString(li?.number), 1)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
              ])
            ])
          ]),
          _hoisted_138,
          _createElementVNode("div", _hoisted_139, [
            _hoisted_140,
            _hoisted_141,
            _createElementVNode("div", _hoisted_142, [
              _createElementVNode("table", _hoisted_143, [
                (!item.value?.emailAdresses)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_144, _hoisted_146))
                  : (_openBlock(), _createElementBlock("div", _hoisted_147, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value?.emailAdresses, (li) => {
                        return (_openBlock(), _createElementBlock("tbody", {
                          key: li.label
                        }, [
                          _createElementVNode("tr", _hoisted_148, [
                            _hoisted_149,
                            _createElementVNode("td", _hoisted_150, [
                              _createElementVNode("p", _hoisted_151, _toDisplayString(li?.label), 1)
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_152,
                            _createElementVNode("td", _hoisted_153, [
                              _createElementVNode("p", _hoisted_154, _toDisplayString(li?.email), 1)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
              ])
            ])
          ]),
          _hoisted_155,
          _createElementVNode("div", _hoisted_156, [
            _hoisted_157,
            _hoisted_158,
            _createElementVNode("div", _hoisted_159, [
              _createElementVNode("table", _hoisted_160, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_161, [
                    _hoisted_162,
                    _createElementVNode("td", _hoisted_163, [
                      _createElementVNode("p", _hoisted_164, _toDisplayString(item.value?.incest?.sleeping_arrangement), 1)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_165, [
                    _hoisted_166,
                    _createElementVNode("td", _hoisted_167, [
                      _createElementVNode("p", _hoisted_168, _toDisplayString(item.value?.incest?.others), 1)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_169, [
                    _hoisted_170,
                    _createElementVNode("td", _hoisted_171, [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", _hoisted_172, _toDisplayString(item.value?.incest?.same_bed_with), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_173, [
                    _hoisted_174,
                    _createElementVNode("td", _hoisted_175, [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", _hoisted_176, _toDisplayString(item.value?.incest?.same_room_with), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_177, [
                    _hoisted_178,
                    _createElementVNode("td", _hoisted_179, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value?.incest?.abused.form, (li) => {
                        return (_openBlock(), _createElementBlock("ul", { key: li }, [
                          _createElementVNode("li", _hoisted_180, _toDisplayString(li), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_181, [
                    _hoisted_182,
                    _createElementVNode("td", _hoisted_183, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value?.incest?.present.form, (li) => {
                        return (_openBlock(), _createElementBlock("ul", { key: li }, [
                          _createElementVNode("li", _hoisted_184, _toDisplayString(li), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(LoadingModal, {
        show: showSync.value,
        noBtn: "",
        title: "Please wait..",
        content: "System is currently loading the report based on the selected filter."
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})